// src/lib/analytics.js
// Small GA4 helper with consent gating and SPA helpers.

let _initialized = false;
let _measurementId = null;

export function hasConsent() {
  try {
    return localStorage.getItem('ga_consent') === 'granted';
  } catch (e) {
    return false;
  }
}

export function grantConsent(measurementId) {
  try {
    localStorage.setItem('ga_consent', 'granted');
  } catch (e) {}
  if (measurementId) init(measurementId);
}

export function revokeConsent() {
  try {
    localStorage.setItem('ga_consent', 'denied');
  } catch (e) {}
}

export function init(measurementId) {
  if (_initialized) return;
  if (!measurementId) return;
  _measurementId = measurementId;
  // Inject gtag script
  const scriptId = 'ga-gtag-script';
  if (document.getElementById(scriptId)) {
    _initialized = true;
    return;
  }
  const script = document.createElement('script');
  script.id = scriptId;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);} // eslint-disable-line no-inner-declarations
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', measurementId, { anonymize_ip: true });
  _initialized = true;
}

export function pageview(path) {
  if (!_initialized || !hasConsent()) return;
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', { page_path: path });
}

export function event(name, params = {}) {
  if (!_initialized || !hasConsent()) return;
  if (typeof window.gtag !== 'function') return;
  try {
    window.gtag('event', name, params);
  } catch (e) {
    // swallow
  }
}

export default {
  hasConsent,
  grantConsent,
  revokeConsent,
  init,
  pageview,
  event,
};
